(function () {
  'use strict';

  function getData() {
    const el = document.getElementById('final-blog-sections-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Final Blog Sections: invalid JSON', e);
      return null;
    }
  }

  function extractYoutubeId(url) {
    if (!url) return '';
    const trimmed = String(url).trim();
    if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;
    const pattern = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = trimmed.match(pattern);
    return match ? match[1] : '';
  }

  let audioInstanceCounter = 0;

  const sectionMap = {

    'final-blog-qoutes-text-section': {
      type: 'quote',
      render: function (block) {
        const heading = (block.heading || '').trim();
        const firstLetter = heading.charAt(0);
        const headingText = heading.slice(1);
        return `
          <div class="fbqs-top-row">
            <span class="fbqs-number">${block.number || ''}</span>
            <span class="fbqs-dotted-line"></span>
            <div class="fbqs-watermark">
              <span class="fbqs-watermark-title">${block.watermark_title || ''}</span>
              <span class="fbqs-watermark-subtitle">${block.watermark_subtitle || ''}</span>
            </div>
          </div>
          <div class="fbqs-heading-desc-wrapper">
            <h3 class="fbqs-heading">
              <span class="fbqs-first-letter">${firstLetter}</span><span class="fbqs-heading-text">${headingText}</span>
            </h3>
            ${block.description ? `<p class="fbqs-description">${block.description.trim()}</p>` : ''}
          </div>
        `;
      }
    },
    'final-blog-quotes-text-section': {
      type: 'quote',
      render: function (block) {
        return sectionMap['final-blog-qoutes-text-section'].render(block);
      }
    },

    'final-blog-stat-section': {
      type: 'stat',
      render: function (block) {
        return `
          <div class="fbst-title">${block.title || ''}</div>
          <div class="fbst-value">${block.value || ''}</div>
          <div class="fbst-subtitle">${block.subtitle || ''}</div>
        `;
      }
    },

    'final-blog-banner-text-section': {
      type: 'banner',
      render: function (block) {
        const rawCitation = (block.citation_text || '').trim();
        const cleanCitation = rawCitation.replace(/^[—–-]+\s*/, '');
        const el1 = block.elephant_one || '//itokri.myshopify.com/cdn/shop/files/flying_elephant_4.png?v=1785330732&width=200';
        const el2 = block.elephant_two || '//itokri.myshopify.com/cdn/shop/files/flying_elephant_4.png?v=1785330732&width=200';
        return `
          <div class="fbbts-inner" style="--fbbts-bg-desktop: url('${block.bg_desktop || ''}'); --fbbts-bg-mobile: url('${block.bg_mobile || block.bg_desktop || ''}');">
            <img class="fbbts-elephant fbbts-elephant--one" src="${el1}" alt="" loading="lazy">
            <img class="fbbts-elephant fbbts-elephant--two" src="${el2}" alt="" loading="lazy">
            <p class="fbbts-quote">${block.quote_text || block.heading || ''}</p>
            ${cleanCitation ? `<p class="fbbts-citation">— ${cleanCitation}</p>` : ''}
          </div>
        `;
      }
    },

    'final-blog-image-with-text-section': {
      type: 'image_text',
      render: function (block) {
        const sideImg = block.side_image || block.image || '';
        const caption = block.caption_text || block.credit || '';
        const bgDesktop = block.bg_desktop || '';
        const bgMobile = block.bg_mobile || bgDesktop;
        return `
          <div class="fbit-inner" style="--fbit-bg-desktop: url('${bgDesktop}'); --fbit-bg-mobile: url('${bgMobile}');">
            <div class="fbit-content">
              <div class="fbit-media">
                ${sideImg ? `<img class="fbit-image" src="${sideImg}" alt="" loading="lazy">` : ''}
                ${caption ? `<p class="fbit-caption fbit-caption--desktop">${caption}</p>` : ''}
                ${caption ? `<p class="fbit-caption fbit-caption--mobile">${caption}</p>` : ''}
              </div>
              <div class="fbit-text">
                ${block.eyebrow_text ? `<p class="fbit-eyebrow"><span class="fbit-eyebrow-dot" aria-hidden="true"></span>${block.eyebrow_text}</p>` : ''}
                ${block.description ? `<p class="fbit-description">${block.description}</p>` : ''}
              </div>
            </div>
          </div>
        `;
      }
    },

    'final-blog-dual-column-text-section': {
      type: 'dual_column',
      render: function (block) {
        const sideImg = block.side_image || block.column1_image || '';
        return `
          <div class="fbdc-row">
            ${sideImg ? `<img class="fbdc-image" src="${sideImg}" alt="" loading="lazy">` : ''}
            ${block.description ? `<p class="fbdc-description">${block.description}</p>` : ''}
          </div>
          ${block.caption_text ? `<p class="fbdc-caption">${block.caption_text}</p>` : ''}
        `;
      }
    },

    'final-blog-audio-section': {
      type: 'audio',
      render: function (block) {
        audioInstanceCounter++;
        const uid = 'fbau-' + audioInstanceCounter;
        const wavePattern = [
          6, 8, 12, 18, 24, 16, 20, 26, 14, 28, 22, 14, 20, 26, 16, 10,
          18, 24, 16, 20, 26, 12, 8, 14, 22, 28, 18, 12, 16, 24, 18, 14,
          20, 26, 16, 10, 18, 26, 14, 8, 12, 20, 26, 18, 12, 22, 28, 16,
          10, 16, 24, 18, 12, 20, 26, 14, 8, 14, 20, 26, 16, 12, 18, 24,
          18, 12, 16, 22, 16, 12, 14, 18, 24, 20, 14, 22, 28, 18, 12, 16,
          20, 26, 14, 18, 24, 16, 10, 14, 20, 26, 18, 12, 22, 26, 16, 12,
          18, 24, 16, 10, 14, 20, 24, 18, 12, 16, 22, 16, 12, 14, 18, 24,
          16, 12, 18, 26, 14, 10, 16, 22, 28, 18, 12, 14, 20, 26, 16, 10,
          8, 14, 20, 24, 16, 12, 10, 8, 6, 6, 8, 10
        ];
        const barsHtml = wavePattern.map(function (h, i) {
          return `<div class="fbau-bar${i < 48 ? ' played' : ''}" style="height: ${h}px;"></div>`;
        }).join('');

        return `
          <div class="fbau-player" id="${uid}" style="--fbau-bg: ${block.bg_color || '#FFFCF8'};">
            <button class="fbau-play-btn" type="button" aria-label="Play audio">
              <svg class="fbau-icon-play" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
              <svg class="fbau-icon-pause" viewBox="0 0 24 24"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>
            </button>
            <div class="fbau-meta">
              <p class="fbau-title">${block.title || ''}</p>
              <p class="fbau-subtitle">${block.subtitle || ''}</p>
              <div class="fbau-wave-row">
                <div class="fbau-waveform">
                  ${barsHtml}
                </div>
                <span class="fbau-time">0:00 / 0:00</span>
              </div>
            </div>
            ${block.audio_url ? `<audio class="fbau-audio-el" src="${block.audio_url}" preload="metadata"></audio>` : ''}
          </div>
        `;
      },
      postRender: function (el, block) {
        const root = el.querySelector('.fbau-player');
        if (!root) return;

        const audio = root.querySelector('.fbau-audio-el');
        const playBtn = root.querySelector('.fbau-play-btn');
        const waveform = root.querySelector('.fbau-waveform');
        const timeDisplay = root.querySelector('.fbau-time');
        const bars = waveform ? Array.from(waveform.querySelectorAll('.fbau-bar')) : [];
        const BAR_COUNT = bars.length || 45;

        if (!audio) {
          if (playBtn) {
            playBtn.disabled = true;
            playBtn.style.opacity = '0.7';
            playBtn.style.cursor = 'not-allowed';
          }
          return;
        }

        function fmt(t) {
          if (!isFinite(t) || isNaN(t)) return '0:00';
          const m = Math.floor(t / 60);
          const s = Math.floor(t % 60).toString().padStart(2, '0');
          return m + ':' + s;
        }

        function updateTime() {
          const dur = audio.duration || 0;
          if (timeDisplay) {
            timeDisplay.textContent = fmt(audio.currentTime) + ' / ' + fmt(dur);
          }
          const pct = dur ? audio.currentTime / dur : 0;
          const activeCount = Math.round(pct * BAR_COUNT);
          bars.forEach(function (bar, i) {
            bar.classList.toggle('played', i < activeCount);
          });
        }

        playBtn.addEventListener('click', function () {
          if (audio.paused) audio.play(); else audio.pause();
        });

        audio.addEventListener('play', function () { root.classList.add('is-playing'); });
        audio.addEventListener('pause', function () { root.classList.remove('is-playing'); });
        audio.addEventListener('timeupdate', updateTime);
        audio.addEventListener('loadedmetadata', updateTime);
        audio.addEventListener('ended', function () { root.classList.remove('is-playing'); });

        if (waveform) {
          waveform.addEventListener('click', function (e) {
            const rect = waveform.getBoundingClientRect();
            const pct = (e.clientX - rect.left) / rect.width;
            if (audio.duration) audio.currentTime = pct * audio.duration;
          });
        }
      }
    },
    'final-blog--images-section': {
      type: 'images',
      render: function (block) {
        const hasImageOne = !!block.image_one;
        const hasImageTwo = !!block.image_two;
        const isDual = hasImageOne && hasImageTwo;

        let imagesHtml = '';
        if (isDual) {
          imagesHtml = `
            <div class="fbim-grid fbim-grid--dual">
              <img class="fbim-image" src="${block.image_one}" alt="" loading="lazy">
              <img class="fbim-image" src="${block.image_two}" alt="" loading="lazy">
            </div>
          `;
        } else {
          const singleImage = block.image_one || block.image_two || '';
          imagesHtml = `
            <div class="fbim-grid fbim-grid--single">
              ${singleImage ? `<img class="fbim-image" src="${singleImage}" alt="" loading="lazy">` : ''}
            </div>
          `;
        }

        return `
          ${imagesHtml}
          ${block.caption_text ? `<p class="fbim-caption">${block.caption_text}</p>` : ''}
        `;
      }
    },
    'final-blog-images-section': {
      type: 'images',
      render: function (block) {
        return sectionMap['final-blog--images-section'].render(block);
      }
    },
    'final-blog--grid-box-section': {
      type: 'grid_box',
      render: function (block) {
        const items = (block.items || []).filter(function (item) { return item && item.title; });
        const itemsHtml = items.map(function (item) {
          const inner = `
            <div class="fbgb-image-wrap">
              ${item.image ? `<img class="fbgb-image" src="${item.image}" alt="" loading="lazy">` : `<div class="fbgb-image-placeholder"></div>`}
            </div>
            <div class="fbgb-content">
              ${item.label ? `<p class="fbgb-item-label">${item.label}</p>` : ''}
              ${item.title ? `<p class="fbgb-item-title">${item.title}</p>` : ''}
              ${item.subtitle ? `<p class="fbgb-item-subtitle">${item.subtitle}</p>` : ''}
              ${(item.price || item.stock_text) ? `
                <div class="fbgb-item-meta">
                  ${item.price ? `<span class="fbgb-item-price">${item.price}</span>` : ''}
                  ${item.stock_text ? `<span class="fbgb-item-stock">${item.stock_text}</span>` : ''}
                </div>` : ''}
            </div>
          `;
          return item.url
            ? `<div class="fbgb-item"><a class="fbgb-item-link" href="${item.url}">${inner}</a></div>`
            : `<div class="fbgb-item">${inner}</div>`;
        }).join('');

        return `
          <div class="fbgb-inner" style="
            --fbgb-bg-color: ${block.background_color || '#FFF5E5'};
            --fbgb-columns-desktop: ${block.columns_desktop || 3};
            background-color: var(--fbgb-bg-color);
          ">
            ${block.eyebrow_text ? `
              <div class="fbgb-eyebrow-wrap">
                <span class="fbgb-eyebrow-line" aria-hidden="true"></span>
                <p class="fbgb-eyebrow">${block.eyebrow_text}</p>
                <span class="fbgb-eyebrow-line" aria-hidden="true"></span>
              </div>` : ''}
            ${block.heading ? `<h2 class="fbgb-heading">${block.heading}</h2>` : ''}
            ${block.description ? `<div class="fbgb-description">${block.description}</div>` : ''}
            <div class="fbgb-grid">${itemsHtml}</div>
          </div>
        `;
      }
    },
    'final-blog-grid-box-section': {
      type: 'grid_box',
      render: function (block) {
        return sectionMap['final-blog--grid-box-section'].render(block);
      }
    },

    'final-blog-youtube-embed-section': {
      type: 'youtube',
      render: function (block) {
        const videoId = extractYoutubeId(block.youtube_url || '');
        const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '';
        return `
          ${block.eyebrow_text ? `<p class="fbyt-eyebrow">${block.eyebrow_text}</p>` : ''}
          <div class="fbyt-frame" data-video-id="${videoId}">
            <div class="fbyt-thumb" style="background-image: url('${thumbUrl}');">
              ${block.overlay_title ? `<p class="fbyt-overlay-title">${block.overlay_title}</p>` : ''}
              <button class="fbyt-play-btn" type="button" aria-label="Play video">
                <svg viewBox="0 0 68 48" width="56" height="40">
                  <path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.49,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.49,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path>
                  <path d="M45,24 27,14 27,34" fill="#fff"></path>
                </svg>
              </button>
              ${block.duration_badge ? `<span class="fbyt-duration">${block.duration_badge}</span>` : ''}
              <span class="fbyt-watch-label">Watch on YouTube</span>
            </div>
          </div>
          ${block.caption_text ? `<p class="fbyt-caption">${block.caption_text}</p>` : ''}
        `;
      },
      postRender: function (el, block) {
        const frame = el.querySelector('.fbyt-frame');
        const playBtn = el.querySelector('.fbyt-play-btn');
        const thumb = el.querySelector('.fbyt-thumb');
        if (!frame || !playBtn || !thumb) return;

        const videoId = frame.dataset.videoId;
        if (!videoId) return;

        function loadVideo() {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('width', '100%');
          iframe.setAttribute('height', '100%');
          iframe.setAttribute('frameborder', '0');
          // 'fullscreen' is required alongside allowfullscreen for the player's
          // own fullscreen button to work inside the iframe on mobile.
          iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
          );
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', block.overlay_title || 'YouTube video');
          iframe.className = 'fbyt-iframe';
          // playsinline=1 keeps playback inside the page on iOS/iPadOS. Without it
          // the video is hijacked into the native fullscreen player, which is why
          // tap-to-pause behaves inconsistently on tablets and in touch emulation.
          iframe.src =
            'https://www.youtube.com/embed/' +
            videoId +
            '?autoplay=1&rel=0&playsinline=1&enablejsapi=1';
          frame.innerHTML = '';
          frame.appendChild(iframe);
        }

        playBtn.addEventListener('click', loadVideo);
        thumb.addEventListener('click', function (e) {
          if (e.target !== playBtn && !playBtn.contains(e.target)) loadVideo();
        });
      }
    }
  };

  function init() {
    const data = getData();
    if (!data) return;

    const renderedSet = new Set();
    const renderedBlocksByType = {};

    Object.keys(sectionMap).forEach(function (className) {
      const config = sectionMap[className];
      const list = data[config.type] || [];
      const elements = document.querySelectorAll('.' + className);

      if (!renderedBlocksByType[config.type]) {
        renderedBlocksByType[config.type] = new Set();
      }

      elements.forEach(function (el, index) {
        if (renderedSet.has(el)) return;
        const block = list[index];
        if (!block) {
          console.warn(`Final Blog Sections: no data at index ${index} for "${className}". Check admin list order/count.`);
          return;
        }
        el.innerHTML = config.render(block);
        renderedSet.add(el);
        renderedBlocksByType[config.type].add(block);

        if (typeof config.postRender === 'function') {
          config.postRender(el, block);
        }
      });
    });

    // Auto-append any metafield sections that have data but no placeholder div was manually added in the article content
    const contentBody = document.getElementById('articleContentBody');
    if (contentBody) {
      const canonicalMap = [
        { className: 'final-blog-quotes-text-section', type: 'quote' },
        { className: 'final-blog-banner-text-section', type: 'banner' },
        { className: 'final-blog-image-with-text-section', type: 'image_text' },
        { className: 'final-blog-dual-column-text-section', type: 'dual_column' },
        { className: 'final-blog-audio-section', type: 'audio' },
        { className: 'final-blog-youtube-embed-section', type: 'youtube' },
        { className: 'final-blog-images-section', type: 'images' },
        { className: 'final-blog-grid-box-section', type: 'grid_box' }
      ];

      canonicalMap.forEach(function (entry) {
        const list = data[entry.type] || [];
        const rendered = renderedBlocksByType[entry.type] || new Set();
        const config = sectionMap[entry.className];
        if (!config) return;

        list.forEach(function (block) {
          if (!rendered.has(block)) {
            const el = document.createElement('div');
            el.className = entry.className;
            el.innerHTML = config.render(block);
            contentBody.appendChild(el);
            if (typeof config.postRender === 'function') {
              config.postRender(el, block);
            }
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();